import SecureLS from "secure-ls"
import { Storage } from "vuex-persistedstate"

const ls = new SecureLS({ isCompression: false })

const storage: Storage = {
    getItem: (key: string) => ls.get(key),
    setItem: (key: string, value: any) => ls.set(key, value),
    removeItem: (key: string) => ls.remove(key),
}

export default storage
